import { render, staticRenderFns } from "./PhieuBaoTraPhong.vue?vue&type=template&id=55f199ca&"
import script from "./PhieuBaoTraPhong.vue?vue&type=script&lang=js&"
export * from "./PhieuBaoTraPhong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports